import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { SaopWizardEvent, SaopWizardEventType } from '@chiroup/core/types/SaopWizardEvent.type';
import { useCallback, useContext } from 'react';
import { MeContext } from '../contexts/me.context';

export const useTrackSaopWizardEvent = () => {
  const { me } = useContext(MeContext);
  const clinicId = me?.selectedClinic?.ID;
  const userId = me?.ID;

  return useCallback(
    (eventType: SaopWizardEventType) => {
      if (!userId || !clinicId) return;

      const body: SaopWizardEvent = {
        clinicId,
        eventType,
        occurredAt: new Date().toISOString(),
      };

      // Engagement must never block navigation or signing.
      void ChiroUpAPI.post('api', '/track-event', { body }).catch(() => {});
    },
    [clinicId, userId]
  );
};
